import { useQuery, useMutation, useQueryClient, UseQueryResult } from '@tanstack/react-query';
import {
  getActions,
  createAction,
  patchAction,
  deleteAction,
  ActionItem,
  ActionCreate,
} from '../api/actionsApi';
import { invalidateNotificationCounts } from './useNotificationCounts';

export const ACTIONS_KEY = ['actions'] as const;
export function actionsQueryOptions(status?: string) {
  return {
    queryKey: ['actions', 'list', status ?? 'all'] as const,
    queryFn: () => getActions(status),
    staleTime: 30 * 1000,
  };
}
export function useActions(status?: string): UseQueryResult<ActionItem[], Error> {
  return useQuery(actionsQueryOptions(status));
}
export function useCreateAction() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (b: ActionCreate) => createAction(b),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ACTIONS_KEY });
      invalidateNotificationCounts(qc);
    },
  });
}
export function usePatchAction() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, status }: { id: number; status: string }) => patchAction(id, status),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ACTIONS_KEY });
      invalidateNotificationCounts(qc);
    },
  });
}
export function useDeleteAction() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: number) => deleteAction(id),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ACTIONS_KEY });
      invalidateNotificationCounts(qc);
    },
  });
}
